// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"77":"fc6bf7cf","179":"3c2c7f39","396":"6d3b42ce","416":"1ccbf0fc","540":"93cfe88f","640":"bf046206","672":"07fa10f6","804":"729f522c"}[chunkId] + ".js";
};